module.exports = __webpack_public_path__ + "static/media/ypsilibrary2.fa408780.jpg";